import { TrackPageViewProperties } from './properties/track-page-view.properties'

"use strict"

export const onLoad = () => {
    if (!window.onMyWebsite?.properties) {
        throw new Error('On My Website: Unable to track the page view as the properties are undefined');
    }
    
    // Make the method trackPageView global.
    window.onMyWebsite.trackPageView = trackPageView;
    
    if (window.onMyWebsite.properties.trackPageViewOnLoad) {
        window.addEventListener('load', () => {
            setTimeout(async () => {
                await window.onMyWebsite?.trackPageView();
            }, 5000);
        });
    }
}

export const trackPageView = async() => {
    if (!window.onMyWebsite?.properties) {
        throw new Error('On My Website: Unable to track the page view as the properties are undefined');
    }

    const endpoint = '/api/on-my-website/v1.0/page-views/track';
    const onMyWebsiteProperties = window.onMyWebsite.properties;

    const payload: TrackPageViewProperties = {
        reference: onMyWebsiteProperties.reference,
        encodedPathAndQuery: `${window.location?.pathname}${window.location?.search}`,
        umbracoNodeId: onMyWebsiteProperties.umbracoNodeId
    };

    if (
        !onMyWebsiteProperties.captureUserAgent && 
        onMyWebsiteProperties.blockedUserAgents && 
        window.navigator?.userAgent && 
        window.navigator.userAgent != ''
    ) {
        // If we are not capturing user agents, we can still use the user agent in JavaScript to see if it's blocked.
        for (var tt = 1; tt <= onMyWebsiteProperties.blockedUserAgents.length; tt++) {
            if (new RegExp(onMyWebsiteProperties.blockedUserAgents[tt - 1], 'ig').test(window.navigator.userAgent)) {
                return;
            }
        }
    }

    if (
        onMyWebsiteProperties.captureUserAgent && 
        window.navigator?.userAgent && 
        window.navigator.userAgent != ''
    ) {
        payload.userAgent = window.navigator.userAgent;
    }

    if (
        onMyWebsiteProperties.captureReferrer && 
        window.document?.referrer && 
        window.document.referrer != ''
    ) {
        payload.referrer = window.document.referrer;
    }

    // Use the Fetch API if available
    var hasFetch = false;
    if (typeof globalThis.fetch === 'function') {
        hasFetch = true;
    }

    if (hasFetch) {
        await fetch(endpoint, {
            cache: 'no-store',
            keepalive: true,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                if (response.status >= 500 && response.status <= 599) {
                    throw new Error(`On My Website: Track page view returned a ${response.status} error status code from the Fetch API`);
                }
                return false;
            }
            return true;
        });
    } else {
        // Fallback to XMLHttpRequest if Fetch API is not available
        const xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('Connection', 'keep-alive');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Cache-Control', 'no-cache');

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 500 && xhr.status <= 599) {
                    throw new Error(`On My Website: Track page view returned a ${xhr.status} error status code from XMLHttpRequest`);
                }
            }
        };

        xhr.onerror = function () {
            throw new Error(`On My Website: Track page view returned a network error from XMLHttpRequest`);
        };

        xhr.send(JSON.stringify(payload));
    }
}

onLoad();